import { render, staticRenderFns } from "./DocumentDownload.vue?vue&type=template&id=16746f2c&"
import script from "./DocumentDownload.vue?vue&type=script&lang=ts&"
export * from "./DocumentDownload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports